/* Phone Time premium layer — tiny, dependency-free, editor-safe (delegated events). */
(function () {
  'use strict';

  /* ---------- Find your fit: tabs ---------- */
  function selectTab(root, tab) {
    var tabs = root.querySelectorAll('[data-pt-fit-tab]');
    var panels = root.querySelectorAll('[data-pt-fit-panel]');
    var idx = tab.getAttribute('data-pt-fit-tab');
    tabs.forEach(function (t) {
      var on = t === tab;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
    });
    panels.forEach(function (p) {
      p.hidden = p.getAttribute('data-pt-fit-panel') !== idx;
    });
  }

  document.addEventListener('click', function (e) {
    var tab = e.target.closest && e.target.closest('[data-pt-fit-tab]');
    if (tab) {
      var root = tab.closest('[data-pt-fit]');
      if (root) selectTab(root, tab);
      return;
    }

    var btn = e.target.closest && e.target.closest('[data-pt-rail-prev],[data-pt-rail-next]');
    if (btn) {
      var section = btn.closest('[data-pt-section="products"]');
      var rail = section && section.querySelector('[data-pt-rail]');
      if (!rail) return;
      var item = rail.querySelector('.pt-rail__item');
      var step = item ? (item.getBoundingClientRect().width + 16) * 2 : rail.clientWidth * 0.8;
      var dir = btn.hasAttribute('data-pt-rail-next') ? 1 : -1;
      rail.scrollBy({ left: dir * step, behavior: 'smooth' });
    }
  });

  document.addEventListener('keydown', function (e) {
    var tab = e.target.closest && e.target.closest('[data-pt-fit-tab]');
    if (!tab) return;
    var root = tab.closest('[data-pt-fit]');
    if (!root) return;
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-pt-fit-tab]'));
    var i = tabs.indexOf(tab);
    var next = null;
    if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
    else if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
    else if (e.key === 'Home') next = tabs[0];
    else if (e.key === 'End') next = tabs[tabs.length - 1];
    if (next) {
      e.preventDefault();
      selectTab(root, next);
      next.focus();
    }
  });

  /* ---------- Product rail: arrow state ---------- */
  function updateRail(rail) {
    var section = rail.closest('[data-pt-section="products"]');
    if (!section) return;
    var prev = section.querySelector('[data-pt-rail-prev]');
    var next = section.querySelector('[data-pt-rail-next]');
    var max = rail.scrollWidth - rail.clientWidth - 2;
    if (prev) prev.disabled = rail.scrollLeft <= 2;
    if (next) next.disabled = rail.scrollLeft >= max;
  }

  function initRails(scope) {
    (scope || document).querySelectorAll('[data-pt-rail]').forEach(function (rail) {
      if (rail.__ptBound) { updateRail(rail); return; }
      rail.__ptBound = true;
      var ticking = false;
      rail.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { ticking = false; updateRail(rail); });
      }, { passive: true });
      updateRail(rail);
    });
  }

  window.addEventListener('resize', function () { initRails(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initRails(); });
  else initRails();
  document.addEventListener('shopify:section:load', function (e) { initRails(e.target); });
})();
